// extracted by mini-css-extract-plugin
export default {"tariff":"Tariff_tariff__D0skR","price":"Tariff_price__TBGLH","type":"Tariff_type__+gtv1","point":"Tariff_point__pI0r7"};